import { getApi } from "./api";

export class Servicios {
  constructor(data = {}) {
    this.estado = data.estado ?? 0;
    this.mensaje = data.mensaje ?? "";
    this.id = data.id ?? 0;
    this.titulo = data.titulo ?? "";
    this.icono = data.icono ?? "";

    this.serviciosDTOS = (data.serviciosDTOS || []).map(
      x => new ServicioDTO(x)
    );
  }
}

export class ServicioDTO {
  constructor(data = {}) {
    this.idServicio = data.idServicio ?? 0;
    this.servicio = data.servicio ?? "";

    this.productoDTOList = (data.productoDTOList || [])
      .filter(x => Object.keys(x).length > 0)
      .map(x => new ProductoDTO(x));
  }
}

export class ProductoDTO {
  constructor(data = {}) {
    this.servicio = data.servicio ?? "";
    this.producto = data.producto ?? "";
    this.idServicio = data.idServicio ?? 0;
    this.idProducto = data.idProducto ?? 0;
    this.idCatTipoServicio = data.idCatTipoServicio ?? 0;
    this.tipoFront = data.tipoFront ?? 0;
    this.hasDigitoVerificador = data.hasDigitoVerificador ?? false;
    this.tipoReferencia = data.tipoReferencia ?? "";
    this.precio = data.precio ?? 0;
    this.showAyuda = data.showAyuda ?? false;
    this.legend = data.legend ?? "";
    this.logoSrc = data.logoSrc ?? "";
    this.refSrc = data.refSrc ?? "";
  }
}

export async function consultarServicios() {
  try {
    const api = getApi();

    const response = await api.get("Servicios/servicios");

    console.log("Respuesta API:", response.data);
    
    // convertir ARRAY → ARRAY de clases
    return (response.data || []).map(x => new Servicios(x));

  } catch (error) {
    console.error("Error:", error.response?.data || error.message);
    throw error;
  }
}

export async function PagoServicioSinReferencia(model) {
  try {
    const api = getApi();

    const response = await api.post(
      "Servicios/PagoServicioSinReferencia",
      model
    );

    console.log("Respuesta API:", response.data);
    return response.data;

  } catch (error) {
    console.error("Error:", error.response?.data || error.message);
    throw error;
  }
}

export async function PagoServicioConReferencia(model) {
  try {
    const api = getApi();

    const response = await api.post(
      "Servicios/PagoServicioConReferencia",
      model
    );

    console.log("Respuesta API:", response.data);
    return response.data;

  } catch (error) {
    console.error("Error:", error.response?.data || error.message);
    throw error;
  }
}

export async function VerificacionReferencia(model) {
  try {
    const api = getApi();

    const response = await api.post(
      "Servicios/VerificacionReferencia",
      model
    );

    console.log("Respuesta API:", response.data);
    return response.data;

  } catch (error) {
    console.error("Error:", error.response?.data || error.message);
    throw error;
  }
}
export async function SaveLogWS(model) {
  const api = getApi();

  const response = await api.post(
      "Servicios/SaveLogWS",
      model
  );

  return response.data;
}

export async function ValidaPago(model) {
  try {
    const api = getApi();

    const response = await api.post(
      "Servicios/ValidaPago",
      model
    );

    console.log("Respuesta API:", response.data);
    return response.data;

  } catch (error) {
    console.error("Error:", error.response?.data || error.message);
    throw error;
  }
}

export async function ReimpresionTicket(model) {
  try {
    const api = getApi();

    const response = await api.post(
      "Servicios/ReimpresionTicket",
      model
    );

    console.log("Respuesta API:", response.data);
    return response.data;

  } catch (error) {
    console.error("Error:", error.response?.data || error.message);
    throw error;
  }
}

export async function DescargarComprobante(model) {
  try {
    const api = getApi();

    const response = await api.post(
      "Servicios/DescargarComprobante",
      model
    );

    console.log("Respuesta API:", response.data);
    return response.data;

  } catch (error) {
    console.error("Error:", error.response?.data || error.message);
    throw error;
  }
}